// extracted by mini-css-extract-plugin
export var carousel = "WorkingWith-module--carousel--IoQwa";
export var carousel_container = "WorkingWith-module--carousel_container--m6Cs7";
export var slide = "WorkingWith-module--slide--3avPg";